import { Stage, Pipeline } from "../../../utils/types";
import type { PipelineGroup, StageInfoRow } from "./types";

export const buildStagesById = (
  stagesArray: Stage[],
  limit: number
): Record<string, Stage> =>
  stagesArray.reduce((acc: Record<string, Stage>, s: Stage) => {
    acc[s.stage] = { ...s, skip: limit };
    return acc;
  }, {});

export const buildStagesFromPipelines = (
  pipelines: Pipeline[],
  limit: number
): Record<string, Stage> => {
  const flat: Stage[] = pipelines.flatMap((p) => p.stages);
  return buildStagesById(flat, limit);
};

export const buildPipelineGroups = (
  pipelines: Pipeline[]
): PipelineGroup[] =>
  pipelines?.map((p) => ({
    pipelineKey: p?.pipeline_key,
    pipelineName: p?.pipeline_name,
    primaryHexColor: p?.primary_hex_color,
    stageIds: p?.stages.map((s) => s?.stage),
  }));

export const buildStageInfoRows = (
  leadStages?: Array<{
    code?: string;
    name?: string;
    description?: string;
    base_color?: string;
  }>
): StageInfoRow[] =>
  (leadStages ?? []).map((s) => ({
    code: s?.code ?? "",
    name: s?.name ?? "",
    color: s?.base_color ?? "",
    description: s?.description?.trim() ?? "",
  }));
